import { createRouter, createWebHistory } from 'vue-router'
import { auth } from '../auth/auth';
import { useRoute } from 'vue-router'
import { store } from '../stores/userStore.js';

const getSubdomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  
  // Check if we have a subdomain that's not www
  if (parts.length > 2 && parts[0] !== 'www') {
    return parts[0];
  }
  return null;
};

// If accessed via subdomain, hard-redirect to main domain with /place/:slug
const _subdomain = getSubdomain();
if (_subdomain) {
  const parts = window.location.hostname.split('.');
  const mainDomain = parts.slice(1).join('.');
  const port = window.location.port ? `:${window.location.port}` : '';
  window.location.replace(`${window.location.protocol}//${mainDomain}${port}/place/${_subdomain}`);
}

const routes = [
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
  },
    {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/about',
    name: 'about',
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    },
  },
  {
    path: '/square/:method?/:message?',
    name: 'squaredashboard',
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/SquareDashboard.vue')
    },
    meta: { requiresAuth: true }

  },
  {
    path: '/square/callback',
    name: 'SquareCallback',
    component: () => import('../views/SquareCallback.vue'),
    props: route => ({ 
      code: route.query.code,
      state: route.query.state,
      error: route.query.error
    })
  },
  {
    path: '/square/payment',
    name: 'squarePayment',
    component: () => import('../views/SquarePaymentScreen.vue'),
    props: route => ({
      orderId: route.query.orderId,
      amount: Number(route.query.amount),
      merchantId: route.query.merchantId,
      venueId: route.query.venueId,
      orderName: route.query.orderName
    }),
     meta: { modal: false }

  },
  {
    path: '/',
    redirect: (to) => {
      const slug = getSubdomain();
      if (slug) {
        return { name: 'VenueLanding', params: { slug } };
      } else {
        return { name: 'nearby' };
      }
    }
  },
  {
    path: '/nearby',
    name: 'nearby',
    component: () => import('../views/NearbyView.vue'),
    meta: { requiresAuth: false, title: "Charmed - What's Nearby" }
  },
  {
    path: '/:type(store|venue)/:slug',
    name: 'location-by-slug',
    component: () => import('../views/NearbyView.vue'),
    props: route => ({
      slug: route.params.slug,
      type: route.params.type
    }),
    meta: { requiresAuth: false, title: 'Charmed - Location' }
  },
    {
    path: '/place/:slug/:type?/:id?',
    name: 'VenueLanding',
    component: () => import('../views/VenueLanding.vue'),
    props: route => ({
      slug: route.params.slug,
      type: route.params.type,
      id: route.params.id 
    }),
    meta: { requiresAuth: false, title: 'Charmed - Place' }
  },
  {
    path: '/charm/:charm_id',
    name: 'CharmDetail',
    component: () => import('../views/CharmDetail.vue'),
    meta: { modal: false },
    meta: { requiresAuth: false }

  },
    {
    path: '/item/:venue_id/:charm_id',
    name: 'CharmLanding',
    component: () => import('../views/CharmLanding.vue'),
    meta: { modal: false },
    meta: { requiresAuth: false }
  },
  {
    path: '/venue_manager',
    name: 'VenueManager',
    component: () => import('../views/VenueManager.vue'),
    meta: { modal: false },
    meta: { requiresAuth: true }
  },
  {
    path: '/charm_manager',
    name: 'CharmManagerl',
    component: () => import('../views/CharmManager.vue'),
    meta: { modal: false },
    meta: { requiresAuth: true }
  },
    {
    path: '/post_manager',
    name: 'PostManager',
    component: () => import('../views/PostManager.vue'),
    meta: { modal: false },
    meta: { requiresAuth: true }
  },
  {
    path: '/schedule_manager',
    name: 'ScheduleManager',
    component: () => import('../views/ScheduleManager.vue'),
    meta: { modal: false },
    meta: { requiresAuth: true }
  },
  {
    path: '/map_manager',
    name: 'MapManager',
    component: () => import('../views/MapManager.vue'),
    meta: { modal: false },
    meta: { requiresAuth: true }
  },
  {
    path: '/redeem/:reward_id',
    name: 'redeem',
    component: () => import('../views/RedeemView.vue'),
    meta: { requiresAuth: true }

    //sensitive: true
  },
  {
    path: '/nolocation/',
    name: 'nolocation',
    component: () => import('../views/NoLocation.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/email/',
    name: 'email',
    component: () => import('../views/EmailPreferencesView.vue'),
    meta: { requiresAuth: false }
    //sensitive: true
  },
  {
    path: '/test/',
    name: 'test',
    component: () => import('../views/TestView.vue'),
    meta: { requiresAuth: false }
    //sensitive: true
  },
  {
    path: '/cart',
    name: 'cart',
    component: () => import('../views/CartView.vue'),
    meta: { requiresAuth: true, title: 'Charmed - My Cart' }

  },
  {
    path: '/wallet',
    name: 'wallet',
    component: () => import('../views/WalletView.vue'),
    meta: { requiresAuth: true, title: 'Charmed - My Wallet' }
  },
    {
    path: '/org_manager',
    name: 'org_manager',
    component: () => import('../views/OrgManager.vue'),
    meta: { requiresAuth: true, title: 'Charmed - Organization Manager' }
  },
  {
    path: '/user_manager',
    name: 'user_manager',
    component: () => import('../views/UserManager.vue'),
    meta: { requiresAuth: true, title: 'Charmed - User Manager' }
  },
    {
    path: '/messages',
    name: 'messages',
    component: () => import('../views/MessagesView.vue'),
    meta: { requiresAuth: true, title: 'Charmed - Messages' }

  },
  {
    path: '/orders',
    name: 'orders',
    component: () => import('../views/OrdersView.vue'),
    meta: { requiresAuth: true, title: 'Charmed - Orders' }

  },
  {
    path: '/user/:userId?',
    name: 'user',
    component: () => import('../views/UserView.vue'),
    props: route => ({
      userId: route.params.userId,
      userIdQuery: route.query.userId
    }),
    meta: { requiresAuth: true, title: 'Charmed - User Details' }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/SettingsView.vue'),
    meta: { requiresAuth: false, title: 'Charmed - Settings' }

  },
    {
    path: '/signin',
    name: 'signin',
    component: () => import('../views/SignInView.vue'),
    meta: { requiresAuth: false }

  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/PrivacyPolicyView.vue'),
    meta: { requiresAuth: false }

  },
    {
    path: '/terms',
    name: 'terms',
    component: () => import('../views/TermsView.vue'),
    meta: { requiresAuth: false }

  },
  {
    path: '/legal',
    name: 'legal',
    // route level code-splitting
    // this generates a separate chunk (About.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/LegalView.vue'),
    meta: { requiresAuth: false }

  },
    {
    path: '/sticker',
    name: 'Sticker',
    component: () => import('../views/StickerView.vue'),
    meta: { requiresAuth: false }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {

    document.title = to.meta.title || 'Charmed';


  // If path is '/' and slug is not null, redirect to VenueLanding
  if (
    to.path === '/' &&
    typeof to.params.slug !== 'undefined' &&
    to.params.slug !== null
  ) {
    return next({
      name: 'VenueLanding',
      params: { slug: to.params.slug }
    });
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.isAuthenticated) {
      console.log('🚨 Route guard: Authentication required - logging in');
      auth.login();
    } else {
      console.log('🚨 Route guard: Authentication required - logged in');
      next();
    }
  } else {
    console.log('🚨 Route guard: No authentication required');
    next();
  }
});

export default router;

